import {UseFormReturnType} from "@mantine/form";
import {Grid, GridProps, Select, TextInput} from "@mantine/core";
import {USStateSelect} from "../../select/USStateSelect/USStateSelect";
import {Address, pascal} from "@ots-frontend/ots-data";

const DEFAULT_COUNTRIES = [{value: 'US', label: 'United States'}];

export type AddressFormFieldsProps<FormValues extends Record<string, any>> = Omit<GridProps, 'children'> & {
  form: UseFormReturnType<FormValues>
  prefix?: string;
  path?: string;
  names?: Partial<Record<keyof Address, keyof FormValues & string>>;
}

export function AddressFormFields<FormValues extends Record<string, any>>(props: AddressFormFieldsProps<FormValues>) {
  const {
    form,
    prefix,
    path,
    names,
    ...rest
  } = props;

  const resolve = (field: keyof Address) => {
    if (names?.[field]) return names[field] as string;
    if (prefix) return `${prefix}${pascal(field)}`;
    return path ? `${path}.${field}` : (field as string);
  };

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <TextInput
          size="xs"
          label="Street"
          placeholder="123 Main St"
          key={resolve('street')}
          {...form.getInputProps(resolve('street'))}
        />
      </Grid.Col>

      <Grid.Col span={12}>
        <TextInput
          size="xs"
          label="Street 2"
          placeholder="Apt, suite, etc."
          key={resolve('street2')}
          {...form.getInputProps(resolve('street2'))}
        />
      </Grid.Col>

      <Grid.Col span={12}>
        <TextInput
          size="xs"
          label="City"
          placeholder="City"
          key={resolve('city')}
          {...form.getInputProps(resolve('city'))}
        />
      </Grid.Col>

      <Grid.Col span={12}>
        <TextInput
          size="xs"
          label="County"
          placeholder="County"
          key={resolve('county')}
          {...form.getInputProps(resolve('county'))}
        />
      </Grid.Col>

      <Grid.Col span={12}>
        <USStateSelect
          size="xs"
          label="State"
          searchable
          key={resolve('state')}
          {...form.getInputProps(resolve('state'))}
        />
      </Grid.Col>

      <Grid.Col span={12}>
        <TextInput
          size="xs"
          label="Postal code"
          placeholder="Postal code"
          key={resolve('postalCode')}
          {...form.getInputProps(resolve('postalCode'))}
        />
      </Grid.Col>

      <Grid.Col span={12}>
        <Select
          size="xs"
          label="Country"
          placeholder="Country"
          data={DEFAULT_COUNTRIES}
          key={resolve('country')}
          {...form.getInputProps(resolve('country'))}
        />
      </Grid.Col>
    </Grid>
  );
}
